import axios from 'axios';
import apiConfig from '../api.config';

export default function setChainSlugRequest(chainId, newChainSlug) {
  const {
    host,
    URIs: { chainSlug },
  } = apiConfig;

  const uri = `${host}${chainSlug.replace(':chainId', chainId)}`;

  return axios
    .post(uri, JSON.stringify({ slug: newChainSlug }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
